"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FNDMiddleware = void 0;
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
exports.FNDMiddleware = [
    {
        inputs: [
            { internalType: 'address payable', name: '_market', type: 'address' },
            {
                internalType: 'address payable',
                name: '_nftDropMarket',
                type: 'address',
            },
            { internalType: 'address payable', name: '_feth', type: 'address' },
            { internalType: 'address', name: '_worlds', type: 'address' },
            {
                internalType: 'address payable',
                name: '_percentSplitETH',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'FNDMiddleware_NFTs_And_TokenIds_Must_Be_The_Same_Length',
        type: 'error',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'value', type: 'uint256' },
            { internalType: 'uint256', name: 'length', type: 'uint256' },
        ],
        name: 'StringsInsufficientHexLength',
        type: 'error',
    },
    {
        inputs: [],
        name: 'feth',
        outputs: [{ internalType: 'contract FETH', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
        name: 'getAccountInfoV2',
        outputs: [
            { internalType: 'uint256', name: 'ethBalance', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'availableFethBalance',
                type: 'uint256',
            },
            { internalType: 'uint256', name: 'lockedFethBalance', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'getDutchAuction',
        outputs: [
            { internalType: 'uint256', name: 'currentPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'nextPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'blockNumber', type: 'uint256' },
            { internalType: 'uint256', name: 'blockTime', type: 'uint256' },
            { internalType: 'uint256', name: 'totalMinted', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'totalAvailableSupply',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'outstandingRebateBalance',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'totalFundsPendingDistribution',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address', name: 'user', type: 'address' },
        ],
        name: 'getDutchAuctionV3',
        outputs: [
            { internalType: 'uint256', name: 'currentPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'mintedNftCount', type: 'uint256' },
            { internalType: 'uint256', name: 'totalNftCount', type: 'uint256' },
            {
                internalType: 'uint256',
                name: 'outstandingRebateBalance',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'totalFundsPendingDistribution',
                type: 'uint256',
            },
            { internalType: 'uint256', name: 'mintFeePerNftInWei', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
        ],
        name: 'getFees',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.FeeWithRecipient',
                name: 'protocol',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                ],
                internalType: 'struct FNDMiddleware.Fee',
                name: 'creator',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.FeeWithRecipient',
                name: 'owner',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'relativePercentInBasisPoints',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'absolutePercentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.RevSplit[]',
                name: 'creatorRevSplit',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'uint256', name: 'price', type: 'uint256' },
            { internalType: 'address payable', name: 'buyReferrer', type: 'address' },
            { internalType: 'uint256', name: 'worldId', type: 'uint256' },
            {
                internalType: 'uint16',
                name: 'worldTakeRateInBasisPoints',
                type: 'uint16',
            },
        ],
        name: 'getFeesV3',
        outputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.FeeWithRecipient',
                name: 'protocol',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                ],
                internalType: 'struct FNDMiddleware.Fee',
                name: 'creator',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.FeeWithRecipient',
                name: 'owner',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'relativePercentInBasisPoints',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'absolutePercentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.RevSplit[]',
                name: 'creatorRevSplit',
                type: 'tuple[]',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.FeeWithRecipient',
                name: 'world',
                type: 'tuple',
            },
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'amountInWei', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                ],
                internalType: 'struct FNDMiddleware.FeeWithRecipient',
                name: 'buyReferrerFee',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getNFTDetailString',
        outputs: [{ internalType: 'string', name: 'details', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getNFTDetails',
        outputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'bool', name: 'isInEscrow', type: 'bool' },
            { internalType: 'address', name: 'auctionBidder', type: 'address' },
            { internalType: 'uint256', name: 'auctionEndTime', type: 'uint256' },
            { internalType: 'uint256', name: 'auctionPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'auctionId', type: 'uint256' },
            { internalType: 'uint256', name: 'buyPrice', type: 'uint256' },
            { internalType: 'uint256', name: 'offerAmount', type: 'uint256' },
            { internalType: 'address', name: 'offerBuyer', type: 'address' },
            { internalType: 'uint256', name: 'offerExpiration', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'percentInBasisPoints',
                        type: 'uint256',
                    },
                ],
                internalType: 'struct Share[]',
                name: 'shares',
                type: 'tuple[]',
            },
        ],
        name: 'getPercentSplitETH',
        outputs: [
            { internalType: 'address', name: 'splitAddress', type: 'address' },
            { internalType: 'bool', name: 'splitHasBeenDeployed', type: 'bool' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getSellerOrOwnerOf',
        outputs: [
            {
                internalType: 'address payable',
                name: 'ownerOrSeller',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
        ],
        name: 'getSellerOrOwnersFromCollection',
        outputs: [
            {
                internalType: 'address payable[]',
                name: 'ownerOrSellers',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address[]', name: 'nftContracts', type: 'address[]' },
            { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
        ],
        name: 'getSellerOrOwnersOf',
        outputs: [
            {
                internalType: 'address payable[]',
                name: 'ownerOrSellers',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address payable', name: 'recipient', type: 'address' },
        ],
        name: 'getSplitShareLength',
        outputs: [{ internalType: 'uint256', name: 'count', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'getTokenCreator',
        outputs: [
            { internalType: 'address', name: 'creatorAddress', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'market',
        outputs: [
            { internalType: 'contract NFTMarket', name: '', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nftDropMarket',
        outputs: [
            { internalType: 'contract NFTDropMarket', name: '', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'percentSplitETH',
        outputs: [
            { internalType: 'contract PercentSplitETH', name: '', type: 'address' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'probeNFT',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'nftContract', type: 'address' },
            { internalType: 'address payable[]', name: 'buyers', type: 'address[]' },
        ],
        name: 'rebateBuyersFromDutchAuction',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'worlds',
        outputs: [{ internalType: 'contract Worlds', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=FNDMiddleware.generated.js.map